import { LoadingSpinner } from '@web_opxp/components';
import { AuthSelectors } from '@web_opxp/features';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import ENV from '../base/env';
import { IState } from '../store/state';
import { getCurrentSubpage, isAssessmentStarted } from './selectors';
import SessionSubpage from './Session/SessionSubpage';
import { AssessmentActions } from './slice';
import { EAssessmentSubpage } from './types';

export const AssessmentRoute = '/assessment';
export const AssessmentEvaluationRoute = `${AssessmentRoute}/evaluation`;
export const TrainingIntensityRoute = `${AssessmentRoute}/intensity`;
export const TrainingScheduleRoute = `${AssessmentRoute}/schedule`;
export const PeerGroupSelectionRoute = `${AssessmentRoute}/peer-group`;
export const AssessmentCfqRoute = `${AssessmentRoute}/cfq`;
export const SpecialNeedsRoute = `${AssessmentRoute}/special-needs`;
export const TrainingLedRoute = `${AssessmentRoute}/led`;

export interface IPageProps {
  authorized: boolean;
  started: boolean;
  subpage: EAssessmentSubpage;
  onStart: () => void;
}

export const AssessmentPageFC: React.FC<IPageProps> = ({ authorized, started, subpage, onStart }) => {
  React.useEffect(() => {
    if (!authorized || started) {
      return;
    }
    onStart();
  });

  if (!started) {
    return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  }

  switch (subpage) {
    case EAssessmentSubpage.Evaluation:
      return <Redirect to={AssessmentEvaluationRoute} />;
    case EAssessmentSubpage.Session:
      return <SessionSubpage />;
    case EAssessmentSubpage.TrainingSchedule:
      return <Redirect to={TrainingScheduleRoute} />;
    case EAssessmentSubpage.PeerGroup:
      return <Redirect to={PeerGroupSelectionRoute} />;
    case EAssessmentSubpage.SpecialNeeds:
      return <Redirect to={SpecialNeedsRoute} />;
    case EAssessmentSubpage.Intensity:
      return <Redirect to={TrainingIntensityRoute} />;
    case EAssessmentSubpage.LED:
      return <Redirect to={TrainingLedRoute} />;
    case EAssessmentSubpage.CFQ:
      return <Redirect to={AssessmentCfqRoute} />;
    case EAssessmentSubpage.CFQEvaluation:
      return <Redirect to={AssessmentCfqRoute} />;
  }
  return null;
};

export const mapStateToProps = (state: IState) => {
  const authorized = AuthSelectors.isAuthorized(state);
  const started = isAssessmentStarted(state);
  const subpage = getCurrentSubpage(state);
  return {
    authorized,
    started,
    subpage,
  };
};

export const mapDispatchToProps = {
  onStart: AssessmentActions.initAssessment,
};

const AssessmentPage = connect(mapStateToProps, mapDispatchToProps)(AssessmentPageFC);
export default AssessmentPage;
